import { useSocketsStore } from '@/stores/sockets';
import { useSystemAudioMicrophoneStore } from '@/stores/systemAudioMicrophone';
import getSocketId from '@/utils/getSocketId';

export default function useSystemAudioMicControl() {
  const socketsStore = useSocketsStore();
  const systemAudioMicrophoneStore = useSystemAudioMicrophoneStore();

  const initMic = async (fresh: boolean) => {
    if (fresh) {
      await systemAudioMicrophoneStore.initStore({
        socketId: getSocketId(),
        events: {
          onmessage: sendAudioChunk,
          onmessageerror: null,
        },
      });
    } else {
      await systemAudioMicrophoneStore.initStore();
    }
  };

  const startMic = async () => {
    if (!systemAudioMicrophoneStore.isMicOn) {
      socketsStore.sendMessageAudioStreamStart(systemAudioMicrophoneStore.socketId);
      await systemAudioMicrophoneStore.startMic();
    }
  };

  const stopMic = async () => {
    if (systemAudioMicrophoneStore.isMicOn) {
      socketsStore.sendMessageAudioStreamEnd(systemAudioMicrophoneStore.socketId);
      await systemAudioMicrophoneStore.stopMic();
    }
  };

  const sendAudioChunk = (e: MessageEvent<Float32Array>) => {
    const audioBytes = new Float32Array(e.data);
    socketsStore.sendMessageAudioStreamChunk(
      systemAudioMicrophoneStore.socketId,
      new Uint8Array(audioBytes.buffer),
      'as'
    );
  };

  return {
    initMic,
    startMic,
    stopMic,
  };
}
